import { createFileRoute } from '@tanstack/react-router';

import { CrmTriggersPage } from '@/features/admin-terminal/components/crm-triggers';

/**
 * The CRM trigger page (ENG-2172): fire each team-CRM automation by hand, on
 * every host, production included. The page leaves out the preview-only
 * parts when the API says it is production.
 */
export const Route = createFileRoute('/_admin/admin/crm-triggers')({
  component: CrmTriggersPage,
});
